import cloneDeep from 'lodash/cloneDeep';
import { TimeHelpers } from 'helpers/date-helpers';

export class Schedule {
  constructor(store) {
    this.store = cloneDeep(store);
  }

  getStore = () => this.store;

  static prepareStore = schedule =>
    schedule.map(day => ({
      ...day,
      Ranges: day.Ranges.map(interval => ({
        ...interval,
        Dow: day.Dow,
        TimeStart: {
          label: TimeHelpers.timeToAmPm(interval.TimeStart),
          value: TimeHelpers.timeToSeconds(interval.TimeStart),
        },
        TimeEnd: {
          label: TimeHelpers.timeToAmPm(interval.TimeEnd),
          value: TimeHelpers.timeToSeconds(interval.TimeEnd),
        },
      })),
    }));

  setInterval = interval => {
    const day = this.findDay(interval.Dow);
    const index = this.findIntervalIndex(interval.ScheduleID, interval.Dow);
    if (index !== -1) {
      day.Ranges[index] = interval;
    } else {
      day.Ranges.push(interval);
    }
    this.sortDayIntervals(interval.Dow);
  };

  removeInterval = interval => {
    const day = this.findDay(interval.Dow);
    day.Ranges = day.Ranges.filter(
      records => records.ScheduleID !== interval.ScheduleID
    );
    if (!day.Ranges.length) {
      day.Active = false;
    }
  };

  selectInterval = (id, dow) => {
    const interval = this.findInterval(id, dow);
    if (interval) {
      interval.selected = true;
    }
  };

  deselectInterval = () => {
    this.store.forEach(day => {
      day.Ranges.forEach(interval => {
        if (interval.selected) {
          interval.selected = false;
        }
      });
    });
  };

  findDay = dow => {
    return this.store.find(d => d.Dow === dow);
  };

  findInterval = (id, dow) => {
    const day = this.findDay(dow);
    return day.Ranges.find(interval => interval.ScheduleID === id);
  };

  findIntervalIndex = (id, dow) => {
    const day = this.findDay(dow);
    return day.Ranges.findIndex(interval => interval.ScheduleID === id);
  };

  sortDayIntervals = dow => {
    const day = this.findDay(dow);
    if (day) {
      day.Ranges.sort((a, b) => a.TimeStart.value - b.TimeStart.value);
    }
  };

  changeDayStatus = (dow, isActive) => {
    const day = this.findDay(dow);
    day.Ranges.forEach(interval => {
      interval.Active = !isActive && interval.Active;
      interval.selected =
        !isActive && interval.selected ? false : interval.selected;
    });
    day.Active = isActive;
  };

  getFreeIntervals = (dow, duration, interval) =>
    getFreeIntervals(this.findDay(dow).Ranges, duration, interval);
}

export const getFreeIntervals = (intervals, duration, interval) => {
  return calcFreeIntervals(intervals, interval).map(interval => {
    const result = [];
    for (
      let i = interval.timeStart;
      i <= interval.timeEnd;
      i = i + duration * 60
    ) {
      result.push({
        label: TimeHelpers.secondsToTimeInAmPm(i),
        value: i,
      });
    }
    return result;
  });
};

const calcFreeIntervals = (intervals, interval) => {
  const eod = 24 * 3600;
  const results = [];
  const _add = (record, arr) => {
    if (record.timeStart < record.timeEnd) {
      arr.push({
        timeStart: record.timeStart,
        timeEnd: record.timeEnd,
      });
    }
  };

  if (!intervals.length || (intervals.length === 1 && interval)) {
    return [
      {
        timeStart: 0,
        timeEnd: eod,
      },
    ];
  }

  if (intervals.length === 1) {
    const intStart = intervals[0].TimeStart.value;
    const intEnd = intervals[0].TimeEnd.value;

    if (intStart !== 0) {
      results.push({
        timeStart: 0,
        timeEnd: intStart,
      });
    }
    if (intEnd !== eod) {
      results.push({
        timeStart: intEnd,
        timeEnd: eod,
      });
    }

    return results;
  }

  for (let i = 0; i < intervals.length; ++i) {
    const intStart = intervals[i].TimeStart.value;
    const intEnd = intervals[i].TimeEnd.value;
    const freeInterval = {};

    if (i === 0) {
      if (intStart !== 0) {
        freeInterval.timeStart = 0;
        freeInterval.timeEnd = intStart;
        _add(freeInterval, results);
      }
    } else if (i === intervals.length - 1) {
      freeInterval.timeStart = intervals[i - 1].TimeEnd.value;
      freeInterval.timeEnd = intStart;
      _add(freeInterval, results);
      if (intEnd !== eod) {
        freeInterval.timeStart = intEnd;
        freeInterval.timeEnd = eod;
        _add(freeInterval, results);
      }
    } else {
      freeInterval.timeStart = intervals[i - 1].TimeEnd.value;
      freeInterval.timeEnd = intStart;
      _add(freeInterval, results);
    }
  }

  if (interval) {
    const intStart = interval.TimeStart.value;
    const intEnd = interval.TimeEnd.value;

    const updatedInterval = results.find(
      interval => interval.timeEnd === intStart
    );
    if (updatedInterval) {
      const index = results.indexOf(updatedInterval);
      if (results[index + 1]) {
        updatedInterval.timeEnd = results[index + 1].timeEnd;
        results.splice(index + 1, 1);
      } else {
        updatedInterval.timeEnd = intEnd;
      }
    }

    if (!updatedInterval && intStart === 0) {
      results.unshift({
        timeStart: intStart,
        timeEnd: intEnd,
      });
    }
  }

  return results;
};
